import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { ListadoRecepciones } from "./components/ListadoRecepciones";
import { loadConfiguracion } from "../../../../../../redux/modules/configuracion";
import "./styles/SeleccionRecepciones.css";

class SeleccionRecepciones extends Component {
    state = {
        traslado_id: null,
        modo_edicion: false,
        materia_prima_id: null,
    };

    componentWillMount() {
        this.setState({
            traslado_id: this.props.match.params.id,
            modo_edicion: this.props.match.path.includes("edicion-recepciones"),
            materia_prima_id: this.props.match.params.materia_prima_id
                ? parseInt(this.props.match.params.materia_prima_id, 10)
                : null,
        });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    refrescarPesajeAutomatico = () => {
        this.props.loadConfiguracion(false);
    };

    navigateToPesaje = () => {
        this.props.history.replace(
            `/traslados/${this.state.traslado_id}/pesaje-traslado`,
        );
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="traslados_activo"
                    titulo="TRASLADO "
                    subtitulo="Recepciones"
                    noBorder
                >
                    <ListadoRecepciones
                        trasladoId={this.state.traslado_id}
                        regresar={this.regresar}
                        navigateToPesaje={this.navigateToPesaje}
                        modoEdicion={this.state.modo_edicion}
                        materiaPrimaId={this.state.materia_prima_id}
                    />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const loader = state.configuracion.loader;

    return {
        configuraciones,
        loader,
    };
};

export default connect(mstp, { loadConfiguracion })(SeleccionRecepciones);
